// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  name: __t.string(),
  prefix: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  lastUsedAt: __t.option(__t.timestamp()).name("last_used_at"),
  expiresAt: __t.option(__t.timestamp()).name("expires_at"),
});
